import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';
import TextButton from 'components/application/buttons/TextButton';
import TextArea from 'components/application/TextArea';
import Tooltip from 'components/application/Tooltip';

export default function SubmittableField({
  autoFocus,
  isSubmitDisabled,
  onCancel,
  onChange,
  onSubmit,
  placeholderText,
  submitButtonText,
  value,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const isSubmittable = Boolean(value) && value.trim().length > 0;

  const handleSubmit = (e) => {
    isSubmittable && onSubmit(e, value);
  };

  return (
    <>
      <TextArea
        autoFocus={autoFocus}
        autoHeight={true}
        labelVisible={false}
        name='submittableFieldValue'
        onChange={onChange}
        padded={true}
        placeholderText={placeholderText}
        smallFontSize={true}
        value={value}
      />
      <TextButton className='tw-mr-3' color='blue' onClick={onCancel} size='sm'>
        {i18nTShared('cancel')}
      </TextButton>
      <Tooltip
        placement='top'
        tooltip={i18nTShared('errors.blankTextField')}
        trigger={isSubmittable ? 'none' : 'hover'}
      >
        <OutlinedButton
          color='grey'
          disabled={!!(!isSubmittable || isSubmitDisabled)}
          onClick={handleSubmit}
          size='sm'
        >
          {submitButtonText}
        </OutlinedButton>
      </Tooltip>
    </>
  );
}

SubmittableField.propTypes = {
  autoFocus: PropTypes.bool,
  isSubmitDisabled: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  placeholderText: PropTypes.string,
  submitButtonText: PropTypes.string.isRequired,
  value: PropTypes.string,
};

SubmittableField.defaultProps = {
  autoFocus: false,
  placeholderText: null,
  value: '',
};
